<template>
  <div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style=" border-radius: 5px !important;padding-left:0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Vehicle Type</b-navbar-brand>

          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button
                size="sm"
                variant="warning"
                v-if="showMain==false"
                @click="goToMain"
              >New Entry</b-button>

              <b-button
                size="sm"
                class="ml-2"
                :disabled="ExcelBtnName != 'Export as Excel' ? true : false"
                @click="truckType('Excel')"
                variant="outline-info"
                > {{ ExcelBtnName }}
                <b-spinner
                  v-if="ExcelBtnName != 'Export as Excel'"
                  small
                  label="Small Spinner"
                ></b-spinner
              ></b-button>
              
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <b-card class="formCard">
          <b-card-text>
            <div v-if="showMain==true">
              <!-- <b-container> -->
                <b-card style="background:whiteSmoke">
                  <b-row>
                    <b-col md="3">
                      <md-layout md-flex="100">
                        <label>Vehicle Type</label>
                        <b-form-input :formatter="capitalizeAll" id="vehicleType" name="vehicleType" v-model="vehicleType"></b-form-input>
                      </md-layout>
                      <span class="error" v-if="!vehicleType">{{vehicleTypeError}}</span>
                    </b-col>
                    <b-col md="3">
                      <b-button
                        style="margin-top:35px"
                        variant="primary"
                        @click="addVehicleType"
                        id="addButtonLoader"
                      >Add</b-button>
                      <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
                    </b-col>
                  </b-row>
                </b-card>
              <!-- </b-container> -->
            </div>

            <div class="box">
              <!-- /.box-header -->
              <div class="table-responsive tableMain mt-3">
                <table id="vehicleTypeNew" class="table">
                  <thead>
                    <tr>
                      <th>Sr.no</th>
                      <th>Vehicle Type</th>
                      <th>Creation Date</th>
                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item1,index) in vehicleTypeMaster" :key="index">
                      <td>{{index+1}}</td>
                      <td>{{item1.vehicleType}}</td>
                      <td>{{item1.loginTime | moment}}</td>
                      <td>
                        <b-button
                          size="sm"
                          variant="outline-primary"
                          @click="deleteData(item1.vehicleTypeId)"
                        >
                          <md-icon>delete_sweep</md-icon>
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.box-body -->
            </div>
            <!-- <md-layout md-gutter>
          <md-layout md-flex="50"></md-layout>
          <md-layout md-flex="25">
            <md-input-container>
              <label>Upload File</label>
              <md-file
                name="excelUpload"
                id="excelUpload"
                v-model="excelUpload"
                @selected="onFileChange()"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              ></md-file>
            </md-input-container>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="20">
            <md-button
              style="margin-top:18px"
              class="md-raised md-primary md-button-color heght-1px"
              @click="downloadExcel"
              id
            >Download Excel</md-button>
          </md-layout>
            </md-layout>-->
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose6"
      ref="addPop6"
    ></md-dialog-confirm>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../../helper/filters";
import axios from "axios";
import moment from "moment";
import { globalPermissionStatus } from "../../../helper/collection";

export default {
  beforeMount() {
    this.$store.dispatch("setCurrentRoute", "/vehicle/vehicleType");
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/vehicle/vehicleType/");
      if (globalPermissionStatus("vehicleMaster") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("vehicleMaster")
        );
      } else {
        this.$router.push({
          path: "/dashboard"
        });
      }

      this.truckType("Normal");
    } else {
      this.$router.push({
        path: "/Login/"
      });
    }
  },
  data() {
    return {
      ExcelBtnName: "Export as Excel",
      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },
      vehicleType: "",
      showMain: false,
      vehicleTypeMaster: [{}],
      validate: true,
      vehicleTypeError: "",
      excelUpload: "",
      deleteId: ""
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker
  },
  computed: {},
  methods: {
    goToMain() {
      this.showMain = true;
    },
    JqueryFun() {
      return $(function() {
        return $("#vehicleTypeNew").DataTable();
      });
    },

    validateAddVehicleTypeForm() {
      let validate_new = true;

      if (this.vehicleType == "") {
        $("#vehicleType").focus();
        this.vehicleTypeError = "Enter Vehicle Type";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    addVehicleType() {
      this.validateAddVehicleTypeForm();
      if (this.validate != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");

        let new_Type_Data = {
          vehicleType: this.vehicleType
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/addVehicleType.php`,
          data: JSON.stringify(new_Type_Data),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            $("#addButtonLoader").css("display", "block");
            $("#loader").css("display", "none");
            if (result.data.Id != "" && result.data.Id != undefined) {
              this.truckType("Normal");
              this.vehicleType = "";
              this.vehicleTypeError = "";
              this.$refs["addPop"].open();
              this.showMain = false;
            }
          })
          .catch(error => {});
      }
    },

    truckType(type) {
      let type_Size = {
        truckType: "truckType",
        type: type
      };

      if(type == "Excel"){
        this.ExcelBtnName = "Downloading....";
      }

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/viewVehicleType.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            this.vehicleTypeMaster = data.truckTypeDetails;
            if (type == "Excel") {
              if (data.truckTypeDetails.length > 0) {
                this.vehicleTypeMaster = data.truckTypeDetails;
                this.totalRows = data.truckTypeDetails.length;
                this.ExcelBtnName = "Export as Excel";
              }
              window.location.href = `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.truckTypeDetails.length > 0) {
                this.vehicleTypeMaster = data.truckTypeDetails;
                this.totalRows = data.truckTypeDetails.length;
                console.log("Vehicle Type Master List response=>", data);
              }
            }
            // this.JqueryFun();
          }
        })
        .catch(error => {});
    },

    downloadExcel() {
      let excelName = {
        excelName: "VehicleTypeMaster",
        validExcel: "yes"
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/downloadMasterExcel.php`,
        data: JSON.stringify(excelName),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            // console.log(data);
            // console.log(data.link12);

            window.open(data.link12);
          }
        })
        .catch(error => {});
    },

    onFileChange() {
      var files = event.target.files || event.dataTransfer.files;
      // this.uploadCheck = files[0];
      var formData = new FormData();

      for (let i = 0; i < files.length; i++) {
        formData.append(`vehicleTypeMaster[]`, files[i]);
      }
      const config = {
        headers: { "content-type": "multipart/form-data" }
      };

      axios
        .post(`${URL_BASE}/uploadExcelDataMaster.php`, formData, config)
        .then(result => {
          console.log(result.data);
          if (result.data == "Only XLXS Format Support") {
            this.alert.content = "Only .xlxs format support";
          } else {
            this.alert.content = result.data;
          }
          this.$refs["addPop"].open();
          this.truckType("Normal");
        })
        .catch(err => {
          throw err;
        });
    },
    deleteData(id) {
      this.deleteId = id;
      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop6"].open();
    },
    onClose6(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "vehicletypemaster",
          tableId: "vehicleTypeId",
          tableIsActive: "isVehicleTypeActive",
          tableVal: this.deleteId
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deleteData.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if (
              data.clientId != "" &&
              
              status == 200 &&
              data
            ) {
              // this.JqueryFun();
              this.truckType("Normal");

              // console.log(data);
            }
          })
          .catch(error => {});
      }
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
.btn-outline-primary:hover .md-icon.md-theme-default.material-icons {
    color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// vehicleType.vue?384c03a4